import type { FC } from 'react';
import { useNormalizedDeviationStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import StudioTableDesktop from '../../StudioTableDesktop';
import StudioBlankSlate from '../../StudioBlankSlate';
import { StudioSection } from '../../../types/store';
import { STUDIO_DEVIATIONS_STREAM } from '../../../../constants';

interface Props {
  activeSection: StudioSection;
}

const ProductsSectionPageContent: FC<Props> = ({ activeSection }) => {
  const { streamId, streamConfig, streamThrottle } = STUDIO_DEVIATIONS_STREAM;
  const {
    items: deviations,
    hasMore,
    hasLess,
  } = useNormalizedDeviationStream(streamId, streamThrottle, streamConfig);

  // we have a special case on commissions where we show the blank slate when all commissions are closed
  // for now we don't have a backend flag for this so we do it when there's a single results page
  const isGalleriesSection = activeSection === StudioSection.PRODUCTS_PREMIUM_GALLERY;
  const isCommissionsSection = activeSection === StudioSection.PRODUCTS_COMMISSION;
  const isSinglePage = !hasMore && !hasLess;
  const allCommissionsClosed =
    isCommissionsSection &&
    isSinglePage &&
    deviations.every(deviation => deviation.commission?.status === -1);
  const hasDeviations = deviations.length > 0;
  if ((!hasDeviations && !isGalleriesSection) || allCommissionsClosed) {
    return <StudioBlankSlate />;
  }

  return <StudioTableDesktop />;
};
ProductsSectionPageContent.displayName = 'ProductsSectionPageContent';

export default ProductsSectionPageContent;
